<template>
  <div id="login">
    <v-card elevation="15" max-width="600" class="mx-auto my-12">
      <div
        class="d-flex flex-column justify-space-between align-center"
        v-if="dataReady"
      >
        <v-container>
         <div class="d-flex flex-column justify-space-between align-center">
            <v-img
              id="img_vg"
              :src="require('@/assets/LOGO_VGROUP_HONDA_RED.png')"
            ></v-img>
          </div>
          <br />
          <pre style="margin-left: -45px">
          <label >ตัวอย่าง</label>
          <label style="color:#871B12" >Username : Anurak.dau</label>
          <label >(ชื่อภาษาอังฤษ จุด นามสกุลสามตัวแรก)</label>
          <label style="color:#871B12">Password : 1234567890123</label>
          <label >(เลขที่บัตรประชาชน)</label>
          </pre>
          <v-text-field
           outlined
            prepend-icon="mdi-account"
            v-model="form.userName"
            label="Username"
          ></v-text-field>
          <v-text-field
           outlined
            prepend-icon="mdi-lock"
            v-model="form.userPassword"
            label="Password"
            type="password"
          ></v-text-field>
          <br />
          <template v-if="hidePrivacy">
            <v-btn color="teal" @click="onSubmit()" dark large block
              >Login</v-btn
            >
          </template>
          <template v-if="!hidePrivacy">
            <v-bottom-sheet v-model="sheet" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal" dark v-bind="attrs" v-on="on" block>
                  Login
                </v-btn>
              </template>
              <v-sheet>
                <v-row>
                  <v-col>
                    <v-btn
                      class="mt-6"
                      text
                      color="error"
                      @click="sheet = !sheet"
                    >
                      close
                    </v-btn>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn
                      class="mt-6 "
                      text
                       color="teal"
                      @click="onSubmitPrivacy()"
                    >
                      ยอมรับเงื่อนไข - Agree
                    </v-btn>
                  </v-col>
                </v-row>
                <div>
                  <v-card id="xxxxxx" class="overflow-y-auto" max-height="500">
                    <div class="a" v-html="privacyConfigDetail"></div>
                    <v-btn
                      color="teal"
                      @click="onSubmitPrivacy()"
                      dark
                      large
                      block
                      >ยอมรับเงื่อนไข - Agree</v-btn
                    >
                  </v-card>
                </div>
              </v-sheet>
            </v-bottom-sheet>
          </template>
        </v-container>
      </div>
      <div v-if="!dataReady" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import VuetifyLogo from '../logo'
export default {
  components: {
    VuetifyLogo
  },
  name: 'Login',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_id_login_emp }, function (data) {})
  },
  data () {
    return {
      session: this.$session.getAll(),
      sheet: false,
      profile: [],
      privacyConfigDetail: '',
      privacyConfigCode: '',
      menu: [],
      data: [],
      date: new Date(),
      formCheckPrivacy: {
        privacyConfigCode: '',
        userCode: '',
        privacyStatus: '',
        userTypeGroup: ''
      },
      form: {
        userLineuserId: '',
        userLinepictureUrl: '',
        userName: '',
        userPassword: ''
      },
      dataReady: true,
      hidePrivacy: true,
      AccessKey: '',
      ApplicationKey: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    await this.removeItemLocalstorage()
    await this.checkLiffLogin()
  },
  methods: {
    async removeItemLocalstorage () {
      this.$session.destroy()
      this.$session.clear()
    },
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      console.log('getDecodedIDToken', this.$liff.getDecodedIDToken())
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          _this.form.userLinepictureUrl = profileLine.pictureUrl
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
      await _this.getDataEmp(_this.form)
    },

    async getDataEmp (dt) {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            this.dataReady = true
            this.$session.start()
            this.$session.set('data', response.data[0])
            localStorage.empCode = response.data[0].empCode
            localStorage.roll = response.data[0].userTypeGroup
            localStorage.setItem('data', JSON.stringify(response.data[0]))
            localStorage.setItem('dataByHR', JSON.stringify(response.data[0]))
            this.getGetTokens(response.data[0])
          } else {
            this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.getPrivacy()
          this.dataReady = true
        })
    },
    async getPrivacy () {
      this.dataReady = false
      this.formPrivacy = {}
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_privacy/get?RECORD_STATUS=N&privacyConfigStatus=ON'
        )
        .then(async (response) => {
          this.hidePrivacy = false
          this.dataReady = true
          this.privacyConfigDetail = response.data[0].privacyConfigDetail
          this.formCheckPrivacy.privacyConfigCode =
            response.data[0].privacyConfigCode
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.hidePrivacy = true
          this.dataReady = true
          console.log('getPrivacy', error)
        })
    },
    async onSubmit () {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/auth?userName=' +
            this.form.userName +
            '&userPassword=' +
            this.form.userPassword
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            if (response.data[0]) {
              this.$session.start()
              // Start form lineid , lineurl to session
              response.data[0].userLineuserId = this.form.userLineuserId
              response.data[0].userLinepictureUrl = this.form.userLinepictureUrl
              // END form lineid , lineurl to session
              this.$session.start()
              this.$session.set('data', response.data[0])
              localStorage.empCode = response.data[0].empCode
              localStorage.roll = response.data[0].userTypeGroup
              localStorage.setItem('data', JSON.stringify(response.data[0]))
              localStorage.setItem('dataByHR', JSON.stringify(response.data[0]))
              this.form.LAST_USER = response.data[0].userName
              this.editData(response.data[0].userId, this.form, response.data[0])
            } else {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง1', 'error')
            }
          } else {
            this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง2', 'error')
          console.log('onSubmit', error)
        })
    },
    async onSubmitPrivacy () {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/auth?userName=' +
            this.form.userName +
            '&userPassword=' +
            this.form.userPassword
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
          // ExpireDateDiff
            if (response.data[0].ExpireDateDiff < 1) {
              this.dataReady = true
              this.$swal(
                'ผิดพลาด',
                'Account หมดอายุ กรุณาติดต่อเจ้าหน้าที่',
                'error'
              )
            } else {
              // Start form lineid , lineurl to session
              response.data[0].userLineuserId = this.form.userLineuserId
              response.data[0].userLinepictureUrl = this.form.userLinepictureUrl
              // END form lineid , lineurl to session
              this.$session.start()
              this.$session.set('data', response.data[0])
              localStorage.roll = response.data[0].userTypeGroup
              localStorage.setItem('data', JSON.stringify(response.data[0]))
              localStorage.setItem('dataByHR', JSON.stringify(response.data[0]))
              this.form.LAST_USER = response.data[0].userName
              this.editData(response.data[0].userId, this.form, response.data[0])
            }
          } else {
            this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง3', 'error')
          console.log('onSubmitPrivacy', error)
        })
    },
    async editData (ID, DT, RS) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user/edit/" + ID,
          DT
        )
        .then(async (response) => {
          this.getGetTokens(RS)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('editData', error)
        })
    },
    getGetTokens (dt) {
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_application/get?masApplicationName=HRM"
        )
        .then(async (response) => {
          this.$session.set(
            'ApplicationKey',
            response.data[0].masApplicationToken
          )
          localStorage.ApplicationKey = response.data[0].masApplicationToken
          let date = this.getDateTh()
          localStorage.dateExpire = date
          this.getMenu(dt)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getGetTokens', error)
        })
    },
    async getMenu (dt) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_menu/get?RECORD_STATUS=N&userTypeGroup=' +
            dt.userTypeGroup
        )
        .then(async (response) => {
          this.$session.set('menu', response.data)
          this.$session.set('AccessKey', 'STuhjFa3JApgnEferZ68aMxjqM5BYRLtEJ4dqMJaDZHh2zBHgT4vn4SEZfmP4TaJYkhWN3d6XnGhcQskqK2VbbGe4v7SxHsNNVpJ')
          localStorage.AccessKey = 'STuhjFa3JApgnEferZ68aMxjqM5BYRLtEJ4dqMJaDZHh2zBHgT4vn4SEZfmP4TaJYkhWN3d6XnGhcQskqK2VbbGe4v7SxHsNNVpJ'
          this.$router.push('/HRM/Employee/EmployeeInfo')
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getMenu', error)
        })
    }
  }
}
</script>
<style scoped>
h1,
h3,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
h3 {
  text-align: center;
}
.a >>> .ql-align-center {
  text-align: center;
}
a {
  color: #42b983;
}
#danger {
  color: red;
}
#login {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 5px; */
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 60px;
}
#xxxxxx {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 10px; */
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.a.data-450 {
  max-height: 450px;
  overflow-y: auto;
  /* margin-bottom: -10px; */
}
#img_vg {
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/LoginEmp.vue